<header id="overlays" class="main-header">
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <a [routerLink]="['/dashboard']">
            <img class="logo-mini navbar-brand" style="padding-top: 0px;height: 45px;padding-right: 10px;"
                src="assets/img/EY_Logo.png" />
        </a>
       

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
        aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
        </button>
    
     <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav mr-auto">
            <!-- HOME Link -->
            <!-- <li class="nav-item">
                <a href="#" [routerLink]="['/dashboard']" style="font-size: 12px; padding-left: 10px; padding-right: 10px;">
                    HOME
                </a>
            </li> -->
            <li class="nav-item">
                <a href="#" [routerLink]="['/dashboard']" class="nav-link" style="font-size: 12px; padding-left: 10px; padding-right: 10px;">
                    HOME
                </a>
            </li>
    
            <!-- CREATE REQUEST Dropdown (ng-bootstrap) -->
            <li class="nav-item dropdown" *ngIf="this._global.IsAdmin || this._global.IsLocationSPOC" ngbDropdown>
                <a class="nav-link dropdown-toggle" ngbDropdownToggle style="font-size: 12px; padding-left: 10px; padding-right: 10px;">
                    CREATE REQUEST
                </a>
                <div ngbDropdownMenu aria-labelledby="dropdown01">
                    <a class="dropdown-item" [routerLink]="['/admin/create-recovery']">Create New Record</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" [routerLink]="['/create/upload-Recovery']">Bulk Upload</a>
                </div>
            </li>
    
            <!-- VIEWS Dropdown (ng-bootstrap) -->
            <li class="nav-item dropdown" *ngIf="this._global.IsAdmin || this._global.IsLocationSPOC" ngbDropdown>
                <a class="nav-link dropdown-toggle" ngbDropdownToggle style="font-size: 12px; padding-left: 10px; padding-right: 10px;">
                    VIEWS
                </a>
                <div ngbDropdownMenu aria-labelledby="dropdown01">
                    <a class="dropdown-item" [routerLink]="['/admin/view-recovery']">VIEW ALL RECORDS</a>
                </div>
            </li>
    
            <!-- FINANCE Dropdown (ng-bootstrap) -->
            <li class="nav-item dropdown" *ngIf="this._global.IsAdmin || this._global.IsFinance" ngbDropdown>
                <a class="nav-link dropdown-toggle" ngbDropdownToggle style="font-size: 12px; padding-left: 10px; padding-right: 10px;">
                    FINANCE
                </a>
                <div ngbDropdownMenu aria-labelledby="dropdown01">
                    <a class="dropdown-item" [routerLink]="['/Finance/view-recovery']">VIEW ALL RECORDS</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" [routerLink]="['/Generate/JournalVoucher']">SEND TO PAYROLL FOR RECOVERY</a>
                </div>
            </li>
    
            <!-- ADMIN Dropdown (ng-bootstrap) -->
            <li class="nav-item dropdown" *ngIf="this._global.IsAdmin" ngbDropdown>
                <a class="nav-link dropdown-toggle" ngbDropdownToggle style="font-size: 12px; padding-left: 10px; padding-right: 10px;">
                    ADMIN
                </a>
                <div ngbDropdownMenu aria-labelledby="dropdown01">
                    <a class="dropdown-item" [routerLink]="['/admin/add-location']">CREATE LOCATION</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" [routerLink]="['/admin/view-location']">VIEW LOCATION</a>
                </div>
            </li>
        </ul>
    
       
    </div> 
         

    <div class="navbar-custom-menu ml-auto d-flex align-items-right">
        <div class="d-flex justify-content-end align-items-center ml-auto nav-link">
            <span style="color: white; font-size: large; font-weight: bolder;">IT RECOVERY SYSTEM</span>
        </div>
        <ul class="nav navbar-nav">
            <!-- User Account Menu -->
            <li ngbDropdown class="nav-item dropdown user user-menu" [autoClose]="'outside'">
                <!-- Menu Toggle Button -->
                <a href="javascript:void(0);" ngbDropdownToggle class="nav-link dropdown-toggle" id="userDropdown" (click)="$event.preventDefault()">
                    <!-- User image -->
                    <img src="assets/img/defaultImage.jpg" class="user-image logo-style" alt="User Image">
                    <!-- Display username -->
                    <span class="d-none d-sm-inline" style="font-size: 11px;">{{ UserName | uppercase }}</span>
                </a>
    
                <!-- Styled Dropdown Menu -->
                <div ngbDropdownMenu aria-labelledby="userDropdown" class="dropdown-menu dropdown-menu-right material-dropdown">
                    <!-- User Info -->
                    <div class="user-header text-center custom-user-header">
                        <img src="{{UserImage}}" class="user-image img-circle" alt="User Image">
                        <p>
                            {{ UserName }} - 
                            {{ this._global.CurrentRole === 'OfficeHead' ? 'Office Spoc' : this._global.CurrentRole }}
                        </p>
                    </div>
                    <!-- User Actions -->
                    <div class="user-footer d-flex justify-content-between px-3">
                        <button id="bookmarkme" (click)="createBookmark($event)" class="btn btn-transparent btn-material">
                             Add to Favourites
                        </button>
                        <button class="btn btn-transparent btn-material" (click)="logoutUser($event)">
                             Sign Out
                        </button>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    
    
    
    

    </nav>
</header>

<div class="content-wrapper">
    <div class="container">
        <section class="content">
            <router-outlet></router-outlet>
        </section>
    </div>
</div>
<!-- <app-footer></app-footer> -->
<!-- </div> -->